import React from 'react';
import { bonuses } from '../data/content';
import { BonusCard } from './BonusCard';

/** The five bonus tools — rendered directly under the volumes in the "What's Included" section. */
export function Bonuses() {
  return <div className="mt-14 rounded-[28px] bg-sage-wash px-4 py-10 sm:px-8 lg:mt-20 lg:px-10 lg:py-14" data-id="element-24" data-mp="aua7afew3lu3">
      <h3 className="text-center font-display text-[28px] leading-tight text-ink sm:text-[38px]" data-id="element-25" data-mp="fsv74dq8c3i0">Plus 5 Ready-to-Use Bonuses</h3>
      <ul className="mt-8 flex flex-wrap justify-center gap-3 sm:gap-4 lg:mt-10 lg:gap-5" data-id="element-26" data-mp="1whsdcd2yg78">
        {bonuses.map(b => <BonusCard key={b.number} bonus={b} data-id="element-27" data-mp="3o1v50e6hlqom" />)}
      </ul>
    </div>;
}